import React from "react";
import SignUp from "../SignUp";
import "../../styles/App.css"

export default function ManagerEmployeeManagement() {

  const employees = ["John Smith", "Amin Yacar", "Hugh Jass"]

  return (
    <div>
      <div className="center-container">
        <h1>Add Employee</h1>
      </div>
      <SignUp />

      <div className="center-container">
        <h2>Current Employees</h2>
        <ul>
          {employees.map((item, index) => (
            <li key={index}>{item}</li>
          ))}
      </ul>
      </div>
    </div>
  )
}